import { Button, Icon, stopEvent } from '@fold-dev/core'
import { TbChevronDown, TbChevronLeft, TbChevronRight } from 'react-icons/tb'

export const CollapseIcon = (props: any) => {
    const { isOpen, ...rest } = props

    return (
        <Button
            subtle
            width={25}
            height={25}
            size="xs"
            style={{ outlineWidth: 0 }}
            className="reveal-on-hover-target"
            onMouseDown={stopEvent}
            {...rest}>
            <Icon
                icon={isOpen ? TbChevronDown : TbChevronLeft}
                size="sm"
                style={{
                    zIndex: 10,
                    //position: 'absolute',
                    //top: '50%',
                    //transform: 'translateY(-75%)',
                    //left: 0,
                    stroke: 'var(--f-color-text-weaker)',
                    strokeWidth: '3',
                }}
            />
        </Button>
    )
}
